module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/rotate_hover_UB.ad5504ed.svg";